import type { RouteRecord } from "vite-react-ssg"

import { RootLayout } from "@/layouts/RootLayout"

/**
 * Route table consumed by vite-react-ssg. The plugin uses this same
 * structure for both client-side routing (SPA) and build-time prerendering
 * (one .html per route under `dist/`).
 *
 * Pages are lazy-loaded so the initial bundle stays small. vite-react-ssg
 * waits for each lazy route to resolve before snapshotting its HTML, so
 * code-splitting and SSG are compatible out of the box.
 *
 * Note on the 404:
 *   We register both `/404` (static, gets prerendered → `dist/404.html`)
 *   and `*` (catch-all, used by the SPA when JS is loaded). Static hosts
 *   like Cloudflare Pages, Netlify, and nginx serve `404.html` automatically
 *   for any request that doesn't match a real file. So the static path is
 *   what visitors actually hit; the splat is the JS-side fallback for
 *   client-side navigation to an unknown URL.
 */
export const routes: RouteRecord[] = [
  {
    path: "/",
    Component: RootLayout,
    children: [
      {
        index: true,
        lazy: () => import("@/pages/Landing"),
      },
      {
        path: "privacy",
        lazy: () => import("@/pages/Privacy"),
      },
      {
        path: "terms",
        lazy: () => import("@/pages/Terms"),
      },
      {
        // V-Q5: confirm-by-email password change. Reads ?token (+ optional
        // ?action=cancel from the "I didn't request this" link) and calls
        // POST /v2/auth/confirm-password-change | /cancel-password-change.
        // Kept (not removed alongside /invite) because production password-
        // change emails from the /v2/auth flow deep-link here — removing
        // would 404 anyone with a pending confirmation email.
        path: "account/confirm-password",
        lazy: () => import("@/pages/ConfirmPassword"),
      },
      {
        path: "404",
        lazy: () => import("@/pages/NotFound"),
      },
      {
        path: "*",
        lazy: () => import("@/pages/NotFound"),
      },
    ],
  },
]
